export default "__VITE_ASSET__DhCONe50__"